import React from 'react';

import { IInner, IOuter } from './DragSource.types';

export const DragSourceComponent: React.FC<IOuter & IInner> = ({ connectDragSource, className, children }) =>
  connectDragSource(<div className={className}>{children}</div>);
